/** True when the signed-in user created the document (only they may share it). */
export const isDocumentOwner = (documentInfo, userInfo) =>
    Boolean(documentInfo && userInfo?.userId) && String(documentInfo.createBy) === String(userInfo.userId);

/** The document's members other than the signed-in user. */
export const getOtherMembers = (documentInfo, userInfo) =>
    (documentInfo?.members ?? []).filter((member) => member.id !== userInfo?.userId);
